<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="" name="0">
        <img src="/static/images/introduce-etc.png" >
      </el-tab-pane>
    </el-tabs>
    <div class="detail">根据企业实际运单，通过信息化系统实现与国家路网中心对接，与行驶轨迹校验获取车辆过路过桥费票据，帮助物流企业解决获取运单ETC发票困难的问题。</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '0'
      }
    },
    mounted: function() {
      if (this.$global.getUrlKey("tab")) this.activeName = this.$global.getUrlKey("tab");
    }
  }
</script>

<style>
  .el-tabs__header {
    margin-bottom: 22px;
  }

  .el-tabs__nav-wrap:after {
    background-color: transparent;
  }

  .el-tabs__active-bar {
    width: 50px;
    height: 3px;
    background-color: #fff;
    border-radius: 1.5px;
  }

  .el-tabs__item {
    font-size: 16px;
    color: #e1e1e1;
  }

  .el-tabs__item.is-active,.el-tabs__item:hover {
    font-size: 18px;
    color: #fff;
  }

  .stance {
    height: 41px;
    margin-bottom: 22px;
  }

  .detail {
    margin-top: 25px;
    font-size: 14px;
    color: #e1e1e1;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/etc.vue